import { defineMessages } from 'react-intl';

const messages = defineMessages({
  RelationStartDateFrom: 'Start date relation from',
  RelationStartDateUntil: 'Start date relation until',
  AddTagToRelation: 'Add tag to relation',
  Relation: 'Relation',
  Assignment: 'Assignment',
  DefaultAssignment: 'Default assignment',
  InvoiceSchedule: 'Invoice schedule',
  Amount: 'Amount',
  FixedAmountRegistrationMethod: 'FixedAmountRegistrationMethod',
  AdvanceRegistrationMethod: 'AdvanceRegistrationMethod',
  PriceGrid: 'Price grid',
  NoRelationsFound: 'No relations found',
  NoInvoiceSchedule: 'No invoice schedule',
  CountRelationsSelected: 'Selected {count} / {total} relations',
  ResetFilters: 'Reset filters',
  Unassigned: 'Unassigned',
  SearchRelations: 'Search relations',
  SelectPriceGrid: 'Select a price grid',
  WithLabels: 'With labels',
  WithoutLabels: 'Without labels',
  InvoiceSchedules: 'Invoice schedules',
  NoInvoicingSchedule: 'No invoicing schedule',
  AmountFrom: 'Amount from',
  AmountTo: 'Amount to',
  WithInvoicingSchedule: 'With invoicing schedule',
  UpdateAmount: 'Update amount',
  UpdateInvoiceStreamAmountConfirmation:
    'This invoice schedule has schedule lines that were manually changed. Do you want to override these changes with the new amount?',
  MsgConfirmChange: 'Changes saved.',
  GlobalActions: 'Global actions',
  RelationGlobalActionsTooltip:
    'Select one or more relations to execute a global action on these relations.',
  SetInvoiceScheduleQueued:
    'Invoice schedules for the selected relations will be added shortly. Click here to view its progress.',
  SetInvoiceSchedule: 'Set invoice schedule',
  Default: 'Default',
  OverrideManualInvoiceStreamScheduleChanges:
    'Override manual amount changes of certain invoice schedule lines.',
  GlobalActionStarted: 'Global action started.',
  Method: 'Method',
  Percentage: 'Percentage',
  InvoiceScheduleOverview: 'Invoice schedule overview',
  ExportToExcel: 'Export to Excel',
  Relations: 'Relations',
  InvoicingVia: 'Invoicing via',
  InvoicingViaRelations: 'Invoicing via relations',
  UpdateInvoiceStreamAmountWarning:
    'Attention: this change only applies to the fixed amounts and advances. And therefore has no effect on hourly rates and registration based invoicing!',
  UpdatePriceGrid: 'Update price grid',
  RoundingMethod: 'Rounding method',
  RoundTo: 'Round to',
  Digits: 'Digits',
  Example: 'Example',
  VatPeriodicity: 'Vat periodicity',
  EmptyVATPeriodicity: 'Empty vat periodicity',
  SendEmail: 'Send email',
  UpdatePriceGridOnSelectedRelations: 'Update price grid on selected relation',
  UpdatePriceGridOnSelectedInvoiceStreams: 'Update price grid on selected invoice schedules',
  UseRelationSetting: 'Use relation setting',
  AlsoResetPriceGridOnSelectedInvoiceStreams:
    'Also reset the price grid on the selected invoice schedules to use the relation setting.',
  ExportToExcelStarted: 'Export to Excel started',
  UpdateInvoiceStreamUser: 'Update invoice stream user',

  UpdateUserForSelectedRelations: 'Update user for selected relations',
  UpdateUserForSelectedInvoiceStreams: 'Update user for selected invoice schedules',
  AlsoResetUserForSelectedInvoiceStreams:
    'Also reset the user for the selected invoice schedules to use the relation setting.',

  UpdateUserInPlannedTasks: 'Do you also want to update the assigned user in tasks?',
  RelationUserIsUnassignedWhichUserDoYouWantToAssignToTasks:
    'You set the relation user to unassigned, which user should we use for updating the assigned user in the tasks?',

  UpdateField: 'Update field',
  SelectAField: 'Select a field',
  SelectYourFilters: 'Select your filters',
  MoreFilters: 'More filters',
  SelectAll: 'Select all',
  IncludeInactiveRelations: 'Show inactive',

  ReprocessInvoiceStreamSchedules: 'Recreate draft invoices for processed invoice schedules',
  ProcessNextInvoiceStreamSchedule: 'Run next planning invoice schedules',
  InvoiceScheduleLine: 'Schedule line',
  InvoiceCreationDate: 'Invoice creation date',
  TaskflowInvoiceCreationDateFrom: 'Invoice creation date from',
  BatchProcessNextScheduleConfirm:
    'Are you sure you want to execute the next invoice planning line for all {count} selected relations?',
  RelationPicker: 'Relations',
  ChooseRelations: 'Choose relations',
  ExecuteTaskflowBilling: 'Taskflow billing',
  ExecuteTaskflowBillingConfirm: 'Are you sure you want to execute the taskflow billing?',
  TaskflowBillingLastLineInfo:
    'The invoice creation date depends on the completion date of the a task. So we search for lines created after {date}, but only reprocess the last one.',
});

export default messages;
